import styled from 'styled-components'

const UlList = styled.ul`
    margin: 0;
    padding-left: 24px;
    li {
        &::marker {
            color: var(--brand);
            font-size: 20px;
        }
    }
`;

export default UlList